import { render, staticRenderFns } from "./ReorderWidgetsModal.vue?vue&type=template&id=e2fe15ca&scoped=true"
import script from "./ReorderWidgetsModal.vue?vue&type=script&lang=js"
export * from "./ReorderWidgetsModal.vue?vue&type=script&lang=js"
import style0 from "./ReorderWidgetsModal.vue?vue&type=style&index=0&id=e2fe15ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fe15ca",
  null
  
)

export default component.exports